export default {
    doctor: 'پزشک',
    normal: '',
    patient: 'بیمار',
    urology:'متخصص ارولوژی',
    donation_clinic:'کلینیک اهدا',
    legal:'مشاور حقوقی',
    genetics:'مشاور ژنتیک',
    nourish:'مشاور تغذیه',
    nurse:'پرستار',
    midwife:'ماما',
    social:'',
    roles: 'نقش ها',
    role: 'نقش',
    glands: 'متخصص داخلی(غدد) ',
    infertility: 'متخصص ناباروری',
    gynecology: 'متخصص سلامت زنان',
    obstetric: 'متخصص بارداری',
    psychological_advisor: 'مشاور روانشناسی',
    cashier: 'صندوقدار',
    radiology: 'متخصص رادیولوژی',
    referral_doctor:	"پزشک معرف",
    secretary:	"منشی",
    developer:	"توسعه دهنده",
    employee:	"کارمند",
    dr: 'دکتر'
}
